import { useEffect } from 'react';
import { Capacitor } from '@capacitor/core';

export function useCapacitor() {
  const isNative = Capacitor.isNativePlatform();
  const platform = Capacitor.getPlatform(); // 'ios' | 'android' | 'web'

  useEffect(() => {
    if (!isNative) return;

    // Handle hardware back button on Android
    const setupBackButton = async () => {
      const { App } = await import('@capacitor/app');
      App.addListener('backButton', ({ canGoBack }) => {
        if (canGoBack) {
          window.history.back();
        } else {
          App.exitApp();
        }
      });
    };

    // Set status bar style on native
    const setupStatusBar = async () => {
      try {
        const { StatusBar } = await import('@capacitor/status-bar');
        await StatusBar.setStyle({ style: 'LIGHT' });
        if (platform === 'android') {
          await StatusBar.setBackgroundColor({ color: '#8448fc' });
        }
      } catch (e) {
        // StatusBar plugin may not be available in all contexts
      }
    };

    // Hide splash screen after app loads
    const hideSplash = async () => {
      try {
        const { SplashScreen } = await import('@capacitor/splash-screen');
        await SplashScreen.hide({ fadeOutDuration: 300 });
      } catch (e) {
        // SplashScreen plugin may not be available
      }
    };

    setupBackButton();
    setupStatusBar();
    hideSplash();
  }, [isNative, platform]);

  return { isNative, platform };
}
